import * as Yup from 'yup';

import type { NumberConstraintEnum } from '@e-socna/data-layer';

import { ResolvableIdSchema } from '../schemas/resolvable-id.schema';

import { useResolvableFloatSchema } from './useResolvableFloatSchema.hook';

export const useResolvableQuantitySchema = (
  numberConstraint: NumberConstraintEnum,
) => {
  const ResolvableFloatSchema = useResolvableFloatSchema(numberConstraint);

  const ResolvableQuantitySchema = Yup.object().shape({
    value: ResolvableFloatSchema.required('La valeur est requise'),
    unitId: ResolvableIdSchema.required("L'unité est requise"),
  });

  return ResolvableQuantitySchema;
};
